import { faForward } from "@fortawesome/free-solid-svg-icons";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import { AvancarEtapaTipoCasoDeAtendimentoController } from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IAcoesAcessoUsuario } from "../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";

interface IBotaoAvancarEtapa {
    AcaoAcessoUsuario: IAcoesAcessoUsuario[] | undefined;
}

export default function BotaoAvancarEtapa(props: IBotaoAvancarEtapa) {
    const { Atendimento, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;

    const textAvancarEtapaSimples = () => {
        if (Atendimento?.ID_ETAPA_TIPO_CASO === 4) {
            return "Solicitação de Reparo Procedente";
        } else {
            return "Avançar";
        }
    };

    const validaBloqueioAcaoPorEtapa = () => {
        if (props?.AcaoAcessoUsuario?.some((acao) => acao.ID_ETAPA === 2)) {
            return props.AcaoAcessoUsuario?.find(
                (acaoFiltrada) => acaoFiltrada.ID_ACAO === 23
            );
        } else if (
            props?.AcaoAcessoUsuario?.some((acao) => acao.ID_ETAPA === 3)
        ) {
            return props.AcaoAcessoUsuario?.find(
                (acaoFiltrada) => acaoFiltrada.ID_ACAO === 24
            );
        } else {
            return props.AcaoAcessoUsuario?.find(
                (acaoFiltrada) => acaoFiltrada.ID_ACAO === 25
            );
        }
    };
    const { execute: AvancarEtapaTipoCasoDeAtendimento, loading: executando } =
        useAsyncCallback(AvancarEtapaTipoCasoDeAtendimentoController);

    return (
        <button
            type="button"
            className="btn btn-sm btn-primary m-1"
            disabled={
                !validaBloqueioAcaoPorEtapa()?.FL_USUARIO_ACESSA ||
                executando ||
                AtendimentoDetalhado.FL_CASO_PARALIZADO ||
                AtendimentoDetalhado.FL_SINCRONIZADO === true
            }
            onClick={() => {
                if (Atendimento?.ID_CASO) {
                    AvancarEtapaTipoCasoDeAtendimento(Atendimento.ID_CASO).then(
                        () => {
                            updateAtendimento();
                            ReloadHistorico();
                        }
                    );
                }
            }}
        >
            <IconOrSpinner
                icon={faForward}
                loadingSize="sm"
                loading={executando}
                className="mr-2"
            />{" "}
            {textAvancarEtapaSimples()}
        </button>
    );
}
